import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDay2026SecondaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

LaborDay2026SecondaryTwo.palette['--sui-palette-background-primary'] = '105 102 68';

export { LaborDay2026SecondaryTwo };